export default __webpack_public_path__ + "static/media/UiUploadImg.2dbcd0c3.svg";